import { call, put, select, takeEvery } from 'typed-redux-saga'
import {
	fileSlice,
	FileNS,
	fileApi,
	fileSelectors,
	showNotificationAction,
	NOTIFICATION_TYPE,
	ErrorCode,
	errorHandler,
	loadersSlice,
} from 'Modules'
import { downloadFile } from 'Helpers'

function* getFile(action: FileNS.GetFile) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { callback, url } = action.payload
		const requestedFiles = yield* select(fileSelectors.getRequestedFiles)
		let resFile = null
		// TODO: add resFile = window.URL.createObjectURL(res) to requestedFiles and analiz project
		if (requestedFiles.has(url)) {
			const files = yield* select(fileSelectors.getFiles)
			resFile = files.get(url)
		} else {
			const res = yield* call(fileApi.getFile, url)
			resFile = window.URL.createObjectURL(res)
			yield* put(fileSlice.actions.setFile({ url, file: resFile }))
			yield* put(fileSlice.actions.setRequestedFile(url))
		}
		yield* put(loadersSlice.actions.hideGlobalLoader())
		callback?.(resFile)
	} catch (error) {
		const { errorCallback } = action.payload
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
		errorCallback?.(error.data?.errors)
	}
}

export function* getFileBlob(action: FileNS.GetFileBlob) {
	try {
		const { url, hideDefaultLoader, callback } = action.payload
		if (!hideDefaultLoader) yield* put(loadersSlice.actions.showGlobalLoader())
		const resFile = yield* call(fileApi.getFile, url)
		yield* put(fileSlice.actions.setFileBlob({ url, file: resFile }))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		callback?.(resFile)
	} catch (error) {
		const { hideDefaultLoader, errorCallback } = action.payload
		if (!hideDefaultLoader) yield* put(loadersSlice.actions.hideGlobalLoader())
		if (error.status === ErrorCode.e404) {
			yield* put(
				showNotificationAction({
					type: NOTIFICATION_TYPE.ERROR,
					message: 'Файл не найден',
				})
			)
		} else yield* call(errorHandler, error)
		errorCallback?.(error.data?.errors)
	}
}

export function* downloadSecureFile(action: FileNS.DownloadSecureFile) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { file, filename } = action.payload
		const res = yield* call(fileApi.getFile, file)
		const url = window.URL.createObjectURL(res)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		downloadFile(url, filename)
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* fileSaga() {
	yield* takeEvery(fileSlice.actions.getFile.type, getFile)
	yield* takeEvery(fileSlice.actions.getFileBlob.type, getFileBlob)
	yield* takeEvery(fileSlice.actions.downloadSecureFile.type, downloadSecureFile)
}
